import { Controller } from '@hotwired/stimulus'
import { hideElement, showElement } from 'utils/toggle_element_visibility'

export default class extends Controller {
  static targets = ["case"]

  initialize() {
    const requestedIds = JSON.parse(this.element.dataset.requestedCaseIds)

    this.caseTargets.forEach((caseTarget) => {
      const caseId = parseInt(caseTarget.dataset.caseId)

      if (requestedIds.includes(caseId)) {
        const requestButton = caseTarget.querySelector("[data-request-button]")
        const requestedLabel = caseTarget.querySelector("[data-requested-label]")

        hideElement(requestButton)
        showElement(requestedLabel)
      }
    })
  }
}
